module.exports = __webpack_public_path__ + "static/admissions@large-dd9e639beb51e785fa6e25bcab2f2211.jpg";